module.exports = __webpack_public_path__ + "static/media/img-10.a434d206.jpg";